var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcContentCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "content_copy_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.694,
    height: 16.694,
    viewBox: "0 0 16.694 16.694",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M0,0H16.694V16.694H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M11.738,1H3.391A1.4,1.4,0,0,0,2,2.391v9.738H3.391V2.391h8.347Zm2.087,2.782H6.173A1.4,1.4,0,0,0,4.782,5.173v9.738A1.4,1.4,0,0,0,6.173,16.3h7.651a1.4,1.4,0,0,0,1.391-1.391V5.173A1.4,1.4,0,0,0,13.825,3.782Zm0,11.129H6.173V5.173h7.651Z",
    transform: "translate(-0.609 -0.304)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContentCopy);
export default __webpack_public_path__ + "static/media/ic_content-copy.46bfc356fd92f7b87055b29de4199e80.svg";
export { ForwardRef as ReactComponent };